import { c as _c } from "react/compiler-runtime";
import { useAppDispatch } from "@store/store-helper";
import { setTableType } from "@store/table/table-slice";
import { TableType } from "@utils/track-event/track-event-list";
import { useEffect } from "react";

/**
 * Sets the correct table type in Redux based on the member table subject.
 * Used by both MembersTable and MembersMobileView to keep table state consistent.
 */
export function useSetMemberTableType(tableSubject) {
  const $ = _c(4);
  const dispatch = useAppDispatch();
  let t0;
  let t1;
  if ($[0] !== dispatch || $[1] !== tableSubject) {
    t0 = () => {
      bb2: switch (tableSubject) {
        case "workspace":
          {
            dispatch(setTableType(TableType.companyMembers));
            break bb2;
          }
        case "project":
          {
            dispatch(setTableType(TableType.projectMembers));
            break bb2;
          }
        case "group":
          {
            dispatch(setTableType(TableType.groupMembers));
            break bb2;
          }
        case "team":
          {
            dispatch(setTableType(TableType.teamMembers));
            break bb2;
          }
        case "activeMembers":
          {
            dispatch(setTableType(TableType.activeMembers));
          }
      }
    };
    t1 = [tableSubject, dispatch];
    $[0] = dispatch;
    $[1] = tableSubject;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
}